export default __webpack_public_path__ + "static/media/arrow-up-circle.4c9bef15.svg";